import axiosInstance from '@/shared/api/axios';
import type { ApiDashboardGetResponse } from '@/shared/types/api/dashboard';

export const apiDashboardGet = async (): Promise<ApiDashboardGetResponse> => {
  const { data } = await axiosInstance.get<ApiDashboardGetResponse>('/dashboard');
  return data;
};
